const scaleWithoutBinaryDrift = (number: number, pow: number): number =>
    Number((number * pow).toFixed(6));

export const roundUp = (number: number, decimalPlace: number): number => {
    const pow = Math.pow(10, decimalPlace);
    return Math.ceil(scaleWithoutBinaryDrift(number, pow)) / pow;
};


export const truncate = (number: number, index = 2) => {
    const pow = Math.pow(10, index);
    return Math.trunc(scaleWithoutBinaryDrift(number, pow)) / pow;
};

export function financial(x:any, decimal = 2):string {
    return Number.parseFloat(x).toFixed(decimal);
}
